import React from "react";
import "./css/dashboard.css";
import Right from "./Right";
import Panel from "./Panel";
import {api} from "./baseFunctions";
import FormItem from "./FormItem";
import RAcomp from "./RAcomp";
import CoolLoader2 from "./CoolLoader2";

import appLangs from "./langs/appIndex";
import {Link} from "react-router";
import {history} from "../store";

export default class RAsheets extends React.Component {
	constructor(){
        super();
        this.getData = this.getData.bind(this);
        this.addComp = this.addComp.bind(this);
        this.updateCmd = this.updateCmd.bind(this);
        this.addExtraComp = this.addExtraComp.bind(this);
        this.addCmd = this.addCmd.bind(this);
        this.updateComps = this.updateComps.bind(this);
        this.delete = this.delete.bind(this);
        this.save = this.save.bind(this);
        this.removeExtraComp = this.removeExtraComp.bind(this);
        this.addFromDB = this.addFromDB.bind(this);
    		this.state = {
                data: [],
    			     comps: [],
                questions: [],
                cmds: false
    		};
	}
	componentDidMount(){
		this.getData();
        
	}
  addCmd(){
    const cmds = [...this.state.cmds];
    cmds.push({type: false, value: ""});
    this.setState({cmds});
  }
  updateCmd(e)//(i, key, val)
  {
    var t = e.target.dataset;

    const cmds = [...this.state.cmds];
    cmds[t.i][t.key] = e.target.value;
    this.setState({cmds});
  }
    delete(id, name)
    {
        var sure = window.confirm("Sikker på du vil slette arket '[" + id + "] " + name + "'?");
        if(sure)
        {
            api("POST", {"type": "deleteRAsheet", id}, (d) => {
                if(!d.error)
                {
                    this.getData();
                }
            }, this.props.auth);
        }
    }
	getData(){
		api("POST", {"type": "getRAsheets"}, (d) => {
			if(!d.error)
			{
				this.setState({
					data: d.data,
          questions: d.questions
				});

        if(this.props.route.path === "/raSheet/new")
        {
            this.addComp();
        }else if(this.props.route.path.indexOf("/raSheet/edit/") !== -1)
        {
            var defaultCmds = this.state.data[Number(this.props.params.key)].endCmds;
            console.log("EndCmds", defaultCmds, Number(this.props.params.key));
            this.setState({cmds: defaultCmds});

            api("POST", {"type": "getRAcomponents", "id": this.props.params.id}, (d) => {
                this.setState({comps: d.components});
            }, this.props.auth);
        }
        if(!window.$.fn.dataTable.isDataTable("#sheets"))
        {
          window.$("#sheets").dataTable({
              "iDisplayLength": 50,
              "order": [[ 0, "desc" ]],
              "language": {
                  "lengthMenu": "Vis _MENU_ pr side",
                  "zeroRecords": "Intet fundet",
                  "info": "Side _PAGE_ / _PAGES_",
                  "infoEmpty": "Intet indhold",
                  "search": "Søg: ",
                   "paginate": {
                      "first":      "Første",
                      "last":       "Sidste",
                      "next":       "Næste",
                      "previous":   "Forrige"
                  },
                  "infoFiltered": "(filterer fra _MAX_ colonner)"
              }
          });
        }
			}
		}, this.props.auth);
	}
    addComp(){
        this.setState({
            comps: [
                        ...this.state.comps,
                        {
                            type: false,
                            comment: false,
                            upload: false,
                            text: {
                                DK: "",
                                UK: ""
                            },
                            correct: 0,
                            //fact: false,
                            fact: {
                                DK: "",
                                UK: "",
                            },
                            extra: []
                        }
                    ]
        });
    }
    addFromDB(i){
        const dbComp = this.state.questions[Number(this.dbSelect[i].value)];
        console.log(i, {
                            type: dbComp.type,
                            dbID: dbComp.id,
                            comment: dbComp.canComment === "1",
                            upload: dbComp.canUpload === "1",
                            text: {
                                DK: dbComp.DK,
                                UK: dbComp.UK
                            },
                            correct: Number(dbComp.correct),
                            fact: dbComp.fact,
                            extra: []
                        });
        var comps = [...this.state.comps];
        comps[i] = {
                            type: dbComp.type,
                            dbID: dbComp.id,
                            comment: dbComp.canComment === "1",
                            upload: dbComp.canUpload === "1",
                            text: {
                                DK: dbComp.DK,
                                UK: dbComp.UK
                            },
                            correct: Number(dbComp.correct),
                            fact: dbComp.fact,
                            extra: []
                        };

        this.setState({comps: comps});

        this.types[i].value = comps[i].type;
        this.comments[i].checked = comps[i].comment;
        this.uploads[i].checked = comps[i].upload;
        this.texts[i].value = comps[i].text.DK;
        this.textsUK[i].value = comps[i].text.UK;
        api("POST", {"type": "getRAcomponent", "id": dbComp.id}, (d) => {
            console.log("CXOMP", d);
            var comps = [...this.state.comps];
            comps[i].extra = d.data[0].extra;
            this.setState({comps: comps});
        }, this.props.auth);
       /* d.type = this.types[key].value;
                d.comment = this.comments[key].checked;
                d.correct = Number(this.answerIsY[key].value);
                d.fact = this.fact[key] && this.fact[key].value.length > 0 ? this.fact[key].value : false;
                d.upload = this.uploads[key].checked;
                d.text.DK = this.texts[key].value;
                d.text.UK = this.textsUK[key].value;*/
        console.log(dbComp, comps);
       
    }
    addExtraComp(id){
        const comps = [...this.state.comps];
        var schema = {
                "DK": "",
                "UK": "",
                "points": 0
            };
        if(comps[id].type === "checkbox")
        {
            schema = {
                "from": 0,
                "to": 0
            };
        }
        comps[id].extra = [
            ...comps[id].extra,
            schema
        ];
        this.setState({comps: comps});
    }
    removeExtraComp(id, compI)
    {
        const comps = [...this.state.comps];
        comps[id].extra.splice(compI, 1);
        this.setState({comps: comps});

    }
    updateComps(ev){
        
    }
    updateComp(d, i)
    {
        var newD = [...this.state.comps];
        newD[i] = d;
        console.log("updateComp()", d, i, newD);
        this.setState({comps: newD});
    }
    save(e){
        e.preventDefault();
        api("POST", {"type": "saveRAsheet", "data": {"name": this.refs.name.value,"hidden": Number(this.refs.hidden.checked), "comps":this.state.comps, "cmds":this.state.cmds}}, (d) => {
                if(!d.error)
                {
                    this.getData();
                    history.push("/raSheet");
                }
                if(d.msg)
                {
                    alert(d.msg);
                }
        }, this.props.auth);
    }
  updateCache = (id) => {
    api("POST", {"type": "updateRAsheetCache", id}, (d) => {
      if(!d.error)
      {
         alert("Opdateret!");
      }
    }, this.props.auth, 1);
  }
	render(){
        var types = {
            "Side-titel": "title",
            "Ja/nej": "yesNo",
            "Vudering": "checkbox",
            "Tekst-felter": "inputs",
            "Underskrift": "signature",
            "Tegning": "drawing",
            "Note": "note",
            "Map-picker": "map",
            "Hent komponent": "db",
        };
        const appLang = appLangs['DK'];
        var defaultName = "";
        var defaultCmds = "";
        var defaultHidden = false;
        if(this.props.route.path.indexOf("/raSheet/edit/") !== -1 && this.state.data[Number(this.props.params.key)])
        {
            defaultName = this.state.data[Number(this.props.params.key)].name;
            defaultCmds = this.state.data[Number(this.props.params.key)].endCmds;
            defaultHidden = this.state.data[Number(this.props.params.key)].hidden;
           /* if(!this.state.cmds)
            {
              this.setState({cmds: defaultCmds});
            }*/
        }
        if(this.state.comps.length === 0)
        {
            if(this.props.route.path === "/raSheet/new")
            {
                //this.addComp();
            }else if(this.props.route.path.indexOf("/raSheet/edit/") !== -1 && this.state.comps.length === 0 && !this.getting)
            {
                console.log("Getting");
                this.getting = 1;
                api("POST", {"type": "getRAcomponents", "id": this.props.params.id}, (d) => {
                    this.setState({comps: d.components});
                    this.getting = false;
                }, this.props.auth);
            }
        }

        const CMDs = ["NEW_RA","NAV","CHECK_POINTS"];
        const routes = ["RA", "NewRA", "Obs", "QR", "Settings"];
		return (
			<Right title="Spørgsmåls ark">
            {
                this.props.route.path === "/raSheet/new" || this.props.route.path.indexOf("/raSheet/edit/") !== -1 ? 
                <Panel title="Nyt ark">
                  <form id="demo-form2" className="form-horizontal form-label-left" action="" onChange={this.updateComps} onSubmit={this.save} method="POST">
                    <FormItem name="Navn" must={1}>
                      <input type="text" required={true} className="form-control col-md-7 col-xs-12" ref="name" key={defaultName} defaultValue={defaultName} required=""/>
                    </FormItem>
                    <FormItem name="Skjult" must={1}>
                      <input type="checkbox" required={true} ref="hidden" key={defaultHidden} defaultChecked={defaultHidden} required=""/>
                    </FormItem>
                    <FormItem name="Afsluttende commands">
                      <table className="table table-striped jambo_table bulk_action">
                        <tbody>
                          <tr>
                            <td>Type</td>
                            <td>Indhold <span className="cursor" onClick={() => this.addCmd()}>+</span></td>
                          </tr>
                          {
                              this.state.cmds ? 
                                this.state.cmds.map((d, key) => <tr key={"cmd" + key}>
                                    <td>
                                      <select name="CMD" data-i={key} data-key="type" onChange={this.updateCmd} defaultValue={d.type}>
                                        <option>Vælg en type</option>
                                        {
                                          CMDs.map((d2, key2) => <option key={key + "CMD" + key2}>{d2}</option>)
                                        }
                                      </select>
                                    </td>
                                    <td>
                                      {
                                        d.type === "NEW_RA" ? 
                                        <div>
                                          Navn:<br/>
                                          <input name="CMD" data-i={key} data-key="value" defaultValue={d.value} onChange={this.updateCmd}/><br/>
                                          <i style={{fontSize: "12px"}}>[oldName] = Navnet på rapporten der bliver afsluttet.</i><br/>
                                          Skema:<br/>
                                          <select name="CMD" data-i={key} data-key="sheet" onChange={this.updateCmd} defaultValue={d.sheet}>
                                            <option>Vælg et skema</option>
                                            {
                                              this.state.data.map((sheet, i) => <option key={key + "sheet" + i} value={sheet.id}>#{sheet.id} {sheet.name}</option>)
                                            }
                                          </select>
                                        </div>
                                        : null
                                      }
                                      {
                                        d.type === "CHECK_POINTS" ? 
                                        <div>
                                          Point er større end:<br/>
                                          <input name="CMD" type="number" data-i={key} data-key="value" defaultValue={d.value} onChange={this.updateCmd}/><br/>
                                          Besked:<br/>
                                          <input name="CMD" type="input" data-i={key} data-key="msg" defaultValue={d.msg} onChange={this.updateCmd}/><br/>
                                          
                                        </div>
                                        : null
                                      }
                                      {
                                        d.type === "NAV" ? 
                                        <div>
                                          Naviger til:<br/>
                                          <select name="CMD" data-i={key} data-key="value" onChange={this.updateCmd}>
                                            <option>Vælg et lokation</option>
                                            {
                                              routes.map((route, i) => <option key={key + "sheet" + i} value={route}>{route}</option>)
                                            }
                                          </select>
                                        </div>
                                        : null
                                      }
                                    </td>
                                </tr>)
                              : null
                            }
                        </tbody>
                      </table>
                    </FormItem>
                    <div className="form-group">
                        <label className="control-label col-md-12 col-sm-12 col-xs-12" style={{"textAlign": "left"}} htmlFor="last-name">
                            Komponenter <span className="required">*</span>
                        </label>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <table className="table table-striped jambo_table bulk_action">
                              <thead>
                                <tr>
                                  <td>Type</td>
                                  <td>Tekst</td>
                                  <td>Korrekt</td>
                                  <td>Kommentar</td>
                                  <td>Upload</td>
                                  <td>Bland <span className="cursor" onClick={() => this.addComp()}>+</span></td>
                                  <td></td>
                                </tr>
                              </thead>
                              
                              {
                                this.state.comps.map((d, key) => {
                                  return (<RAcomp key={"comp" + key} d={d} i={key} amount={this.state.comps.length} types={types} questions={this.state.questions} appLang={appLang} update={(v) => this.updateComp(v, key)} move={(old_index, new_index) => {
                                    let comps = [...this.state.comps];
                                      if (new_index >= comps.length) {
                                        var k = new_index - comps.length;
                                        while ((k--) + 1) {
                                            comps.push(undefined);
                                        }
                                    }
                                    comps.splice(new_index, 0, comps.splice(old_index, 1)[0]);
                                    this.setState({comps: []});
                                    setTimeout(() => this.setState({comps}), 0);
                                  }}/>);
                                })
                              }
                              
                            </table>
                          </div>
                        </div>
                        <input type="submit" value="Opret"/>
                  </form>
                </Panel> : ""
            }

                
                <Panel title="Oversigt" add="/raSheet/new">
					<div className="table-responsive">
                        <CoolLoader2 type="table" show={this.state.data.length === 0}/>
                        <table className="table table-striped jambo_table bulk_action" id="sheets" style={this.state.data.length === 0 ? {display: "none"} : {}}>
                            <thead>
                                <tr className="headings">
                                    <th className="column-title">Ark ID </th>
                                    <th className="column-title">Navn </th>
                                    <th className="column-title">Skjult </th>
                                    <th className="column-title">Cache </th>
                                    <th className="column-title no-link last"><span className="nobr"></span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                            	this.state.data.map((d, key) => {
                            		return (<tr key={key} className={key%2 ? "even pointer" : "odd pointer"}>
                                    <td className=" ">{d.id}</td>
                                    <td className=" ">{d.name}</td>
                                    <td className=" ">{d.hidden}</td>
                                    <td className=" ">
                                    <Link onClick={() => this.updateCache(d.id)}>Opdater cache</Link>
                                    </td>
                                    <td className=" last">
                                        <Link onClick={() => this.setState({comps: [], cmds:d.endCmds.length > 0 ? d.endCmds : false})} to={"/raSheet/edit/" + d.id + "/" + key}>Ret ark</Link> / <Link onClick={() => this.delete(d.id, d.name)}>Slet ark</Link>
                                    </td>
                                </tr>);
                            	})
                            }                     
                            </tbody>
                        </table>
                    </div>
				</Panel>
                <Panel title="Spørgsmål">
                    <CoolLoader2 type="table" show={this.state.questions.length === 0}/>
                    <table className="table table-striped jambo_table bulk_action" id="questions" style={this.state.questions.length === 0 ? {display: "none"} : {}}>
                            <thead>
                                <tr className="headings">
                                    <th className="column-title">ID </th>
                                    <th className="column-title">Text </th>
                                    <th className="column-title">Type </th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.questions.map((d, key) => {
                                    return (<tr key={key} className={key%2 ? "even pointer" : "odd pointer"}>
                                    <td className=" ">{d.id}</td>
                                    <td className=" ">{d.DK}</td>
                                    <td className=" ">{d.type}</td>
                                </tr>);
                                })
                            }                     
                            </tbody>
                        </table>
                </Panel>
			</Right>);
	}
}


// WEBPACK FOOTER //
// ./src/components/RAsheets.js